























































import { Component, Vue } from 'vue-property-decorator'
import CommonHeader from '@/app/components/Common/Header.vue'

@Component({
  components: {
    CommonHeader
  }
})
export default class Complete extends Vue {
  private message:string = ''

  created () {
    if (this.$route.name === 'password-reminder-complete') {
      this.message = 'ご指定のメールアドレスにパスワード再設定用のリンクをお送りしました。'
    } else if (this.$route.name === 'password-resetting-complete') {
      this.message = 'パスワードの再設定が完了しました。'
    }
  }
}
